<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'EntitiesPreviewLexiqueLexique'
});
</script>
<template>
  <ka-container
    code="preview-lexique"
    :options="options">
    <ka-text code="text">
      <span v-html="previewLexiqueItem.Titre" />
    </ka-text>
    <ka-text code="text-1">
      <span v-html="previewLexiqueItem.Description" />
    </ka-text>
    <ka-text
      code="en-savoir-plus-gt"
      :options="{ click: componentInstance.enSavoirPlusGtClick }">
      <span v-html="t('previewLexique.enSavoirPlusGt.value', `En savoir plus >`)" />
    </ka-text>
  </ka-container>
</template>

<script setup lang="ts">
import { syncEntityStore } from 'kapix-components-vue3'
import type { IPropOptions } from 'kapix-components-vue3'
import { entitiesPreviewLexiqueLexiqueComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--lexique-e18')
const component = entitiesPreviewLexiqueLexiqueComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  previewLexique?: PartialEntity<Kapix.Entity.IPreviewLexique>
  options?: IPropOptions
}>(), {
  previewLexique: undefined,
  options: undefined
})

const previewLexiqueItem = syncEntityStore<Partial<Kapix.Entity.IPreviewLexique>>(componentInstance, {
  props,
  propName: 'previewLexique',
  defaultValue: {}
})
</script>
